import React from 'react';
import styles from './SectionHeading.module.css';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  accentColor?: string;
  centered?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  accentColor,
  centered = true,
}) => {
  return (
    <div className={`${styles.heading} ${centered ? styles.centered : ''}`}>
      <h2 className={styles.title}>{title}</h2>
      <div
        className={styles.accent}
        style={accentColor ? { backgroundColor: accentColor } : undefined}
      />
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
